/**
 * La géométrie de `<ActivityCorrectedCopy>` : quelle taille donner à la page, et où lire le point.
 * À part de l'organism pour se tester sans rendu.
 */
export type Size = { width: number; height: number }

/** La largeur du panneau du point, à côté de la page : une carte lisible, sans manger la copie. */
export const SIDE_PANEL_WIDTH = 320
/** `theme.spacing["5"]`, l'écart posé entre la page et le panneau. */
export const SIDE_GAP = 20

/** En dessous, le panneau du point passe sous la page : à côté, la copie deviendrait illisible. */
export const SIDE_BY_SIDE_MIN_WIDTH = 560

/** Sans `fill`, la part de l'écran qu'une page peut prendre en hauteur. */
export const SCROLL_PAGE_MAX_SHARE = 0.7

/** Sous la page : la ligne de commandes, puis la carte du point, bornée aux deux cinquièmes. */
export const BELOW_CONTROLS_HEIGHT = 56
export const BELOW_CARD_SHARE = 0.4

/** La plus grande page au rapport `aspect` qui tient dans `area`. */
export function fitPage(area: Size, aspect: number): Size {
    const width = Math.min(area.width, area.height * aspect)
    return { width, height: width / aspect }
}

/**
 * Le point à côté de la page, ou dessous ? Celle des deux dispositions qui laisse la plus grande
 * page : dans une zone basse, à côté (la page garde toute la hauteur) ; dans une zone haute et
 * étroite, dessous (elle garde toute la largeur).
 */
export function pointGoesBeside(root: Size, aspect: number): boolean {
    if (root.width < SIDE_BY_SIDE_MIN_WIDTH) return false
    const beside = fitPage({ width: root.width - SIDE_PANEL_WIDTH - SIDE_GAP, height: root.height }, aspect)
    const below = fitPage(
        { width: root.width, height: root.height * (1 - BELOW_CARD_SHARE) - BELOW_CONTROLS_HEIGHT },
        aspect
    )
    return beside.width * beside.height > below.width * below.height
}
